// Comparing buses against their group's "bus ideal" (models.Unidad.es_ideal).
// Pure functions, so the rules can be checked with node (idealLogica.test.mjs).

const blank = (v) => v == null || String(v).trim() === ''
const norm = (v) => String(v ?? '').trim().toLowerCase()

// The column that says which group a bus (or an ideal) belongs to.
export const COLUMNA_GRUPO = 'Grupo'

// The ideal a bus is measured against: the one of its own Grupo; if the
// project has a single ideal, that one for every bus; otherwise none.
export function idealDe(unidad, ideales) {
  if (!ideales.length) return null
  const grupo = norm(unidad.atributos?.[COLUMNA_GRUPO])
  if (grupo) {
    const propio = ideales.find(i => norm(i.atributos?.[COLUMNA_GRUPO]) === grupo)
    if (propio) return propio
  }
  return ideales.length === 1 ? ideales[0] : null
}

// An ideal cell that sets no target: empty, or "Definir" / "Por definir" --
// the boards use those for a requirement nobody has settled yet, and
// measuring buses against it would flag every one of them.
export function sinRequisito(valorIdeal) {
  return blank(valorIdeal) || /^(por )?definir$/i.test(String(valorIdeal).trim())
}

// Does this cell stray from the ideal? Only where the ideal sets a target
// (see sinRequisito), never for files. Numbers
// compare as numbers ("24" = "24.0"); the rest ignoring case and spaces. A
// bus with nothing where the ideal expects a value strays too.
export function difiere(columna, valorBus, valorIdeal) {
  if (columna.tipo === 'archivo' || sinRequisito(valorIdeal)) return false
  if (blank(valorBus)) return true
  if (columna.tipo === 'numero') {
    const a = Number(String(valorBus).replace(',', '.'))
    const b = Number(String(valorIdeal).replace(',', '.'))
    if (!Number.isNaN(a) && !Number.isNaN(b)) return a !== b
  }
  return norm(valorBus) !== norm(valorIdeal)
}

// Names of the columns where `unidad` strays from `ideal`.
export function desviaciones(unidad, ideal, columnas) {
  if (!ideal) return []
  return columnas
    .filter(c => c.nombre !== COLUMNA_GRUPO)
    .filter(c => difiere(c, unidad.atributos?.[c.nombre], ideal.atributos?.[c.nombre]))
    .map(c => c.nombre)
}
